<template>
  <div
    class="-favorite -action wt2-sg"
    :title="
      (isFavoriteInProgress()
        ? 'favorite.PROGRESS'
        : isFavorite
        ? 'favorite.REMOVE'
        : 'favorite.ADD') | culture
    "
    @click="onClick()"
    :class="{
      selected: isFavorite,
      '-progress': isFavoriteInProgress(),
    }"
  >
    <transition name="wt2-fade-slow">
      <wt-google-like-loader
        v-show="isFavoriteInProgress()"
        class="-default -progress"
      />
    </transition>
  </div>
</template>

<script>
import app from 'app';
import Vue from 'vue';

export default Vue.extend({
  mounted() {},
  props: {
    asset: { type: Object, required: true },
    isFavorite: {
      type: Boolean,
      require: false,
      default: false,
    },
  },
  methods: {
    onClick() {
      _.debounce(
        () => {
          this.$emit('favorite');
        },
        app.TIME.MENTAL.λ,
        {
          leading: true,
          trailing: false,
        }
      )();
    },
    isFavoriteInProgress() {
      return app.rootStore.getters.isAssetProcessingFavorite
        ? app.rootStore.getters.isAssetProcessingFavorite(this.asset)
        : false;
    },
  },
});
</script>

<style lang="scss">
.wt2-google-like-loader.-default.-progress {
  width: 24px;
  opacity: 1;
  transform: skew(-18deg, -18deg);
  position: absolute;

  svg {
    top: 1px;

    circle {
      stroke: #fdb73b;
      animation: dash 3.5s ease-in-out infinite;
    }
  }
}
</style>
